import { doGet, doPost, doPut } from 'hooks/requests';
import { useAxios } from '../../hooks/useAxios';

const baseUrl = '/payment-plan/';

export const usePaymentPlanService = () => {
    const { remove } = useAxios();

    const createPaymentPlan = (data) => doPost(`${baseUrl}create/`, data, '');

    const getPaymentPlans = (companyId, page, search) => {
        const searchQuery = search?.name ? `&name=${encodeURIComponent(search.name)}` : '';
        return doGet(`${baseUrl}get/?company_id=${companyId}&page=${page}${searchQuery}`);
    };

    const matchPlaidTransactionWithPaymentPlan = (data) => {
        return doPut(`${baseUrl}match-plaid-transaction/`, data);
    };

    const getPaymentPlanById = (companyId, id) => {
        return doGet(`${baseUrl}get-by-id/?company_id=${companyId}&id=${id}`);
    };

    const updatePaymentPlan = (data) => {
        return doPut(`${baseUrl}update/`, data);
    };

    const deletePaymentPlan = (companyId, id) => {
        return remove(`${baseUrl}delete/?company_id=${companyId}&id=${id}`);
    };

    return {
        getPaymentPlans,
        deletePaymentPlan,
        updatePaymentPlan,
        createPaymentPlan,
        getPaymentPlanById,
        matchPlaidTransactionWithPaymentPlan,
    };
};
